import { render } from "./Utenti.vue?vue&type=template&id=527396a6&scoped=true"
import script from "./Utenti.vue?vue&type=script&lang=js"
export * from "./Utenti.vue?vue&type=script&lang=js"

import "./Utenti.vue?vue&type=style&index=0&id=527396a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-527396a6"]])

export default __exports__